// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/compensations",
  ListShort: "/pyr/compensations/short",
  Detail: "/pyr/compensations",
  Create: "/pyr/compensations",
  Update: "/pyr/compensations",
};
